import { NzModalService } from 'ng-zorro-antd/modal';
import { ViewAttachmentsComponent } from 'src/app/modules/clarification-query/view-attachments/view-attachments.component';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { ViewCommentsComponent } from '../view-comments/view-comments.component';
import { AddAttachmentsComponent } from '../add-attachments/add-attachments.component';

export function openAddAttachmentsModal(modalService: NzModalService): void {
  modalService.create({
    nzTitle: 'Add Attachments',
    nzClosable: true,
    nzWidth: '60%',
    nzFooter: null,
    nzAutofocus: null,
    nzContent: AddAttachmentsComponent    
  });
}

export function openViewAttachmentsModal(
  modalService: NzModalService,  
  queryDetail: QueryDetailModel,
  viewPartnerUploadedFiles: boolean
): void {
  const fileAttachments = queryDetail.FileAttachments.filter(
    (s) => s.Partner_UploadedFile === viewPartnerUploadedFiles
  );

  modalService.create({
    nzTitle: 'View Attachments',
    nzClosable: true,
    nzWidth: '60%',
    nzFooter: null,
    nzAutofocus: null,
    nzContent: ViewAttachmentsComponent,
    nzData: {
      queryReferenceNumber: queryDetail.Query_Reference_Number,
      fileAttachments: fileAttachments,
      queryCode: queryDetail.Clarification_Query_Code,
      queryDetailCode: queryDetail.Clarification_Query_Detail_Code,
    },
  });
}
export function openViewCommentsModal(
  modalService: NzModalService,
  queryReferenceNumber: string,
  queryComments: string[]
): void {  

  modalService.create({
    nzTitle: 'View Comments',
    nzClosable: true,
    nzWidth: '60%',
    nzFooter: null,
    nzAutofocus: null,    
    nzContent: ViewCommentsComponent,
    nzData: {
      queryReferenceNumber: queryReferenceNumber,
      queryComments: queryComments,
    },
  });
}